import { Component, Vue, Watch } from 'vue-property-decorator';
import template from './users-overview.vue';
import { User, ModalState, ModalComponents, Permission } from '@/definitions';
import apiService from '@/services/api.service';
import { Action } from '@/store';
import { LocalUser } from '@/store/store.definitions';

@Component({
  mixins: [template],
})
export default class UsersOverview extends Vue {
  users: User[] = [];
  canUpgrade: boolean = false;
  maxUsers: number = 0;

  @Watch('$Store.state.modal.active')
  getNewUsers(active: boolean) {
    if (!active) {
      this.getUsers();
    }
  }

  mounted() {
    this.getUsers();
    this.getPermissions();
  }

  get admin(): LocalUser {
    return this.$Store.state.user;
  }

  async getUsers() {
    try {
      this.users = await apiService.getUsers();
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.users.retrieve_error', type: 'danger' });
    }
  }

  async getPermissions() {
    try {
      const permissions = await apiService.getPermissions();
      this.canUpgrade = (permissions.find(p => p.name === 'ADD_MANAGERS') as Permission).isEnabled;
      this.maxUsers = (permissions.find(p => p.name === 'MAX_USERS') as Permission).value - 1;
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.permissions.retrieve_error', type: 'danger' });
    }
  }

  removeUser(user: User) {
    const modalState: ModalState = {
      component: ModalComponents.REMOVE_USER,
      active: true,
      props: {
        id: user._id,
        name: `${user.firstName} ${user.lastName}`,
        type: 'other'
      }
    }
    this.$Store.dispatch(Action.SHOW_MODAL, modalState);
  }

  addUser() {
    const modalState: ModalState = {
      component: ModalComponents.ADD_USER,
      active: true,
      props: {}
    }
    this.$Store.dispatch(Action.SHOW_MODAL, modalState);
  }

  async setAsManager(id: string) {
    try {
      await apiService.setAdmin(id);
      this.getUsers();
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.users.set_admin_error', type: 'danger' });
    }
  }
}